exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HeaderBackground__container___eVffV {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  overflow: hidden;\n}\n\n.HeaderBackground__background___sFZRS {\n  background-image: url('/static/images/beach.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 110%;\n  height: 110%;\n  position: relative;\n  top: -5%;\n  left: -5%;\n  opacity: 1;\n}\n", ""]);

// exports
exports.locals = {
	"container": "HeaderBackground__container___eVffV",
	"background": "HeaderBackground__background___sFZRS"
};